module.exports = __webpack_public_path__ + "static/media/star.53db8c46.svg";